<template>
  <div class="simple__select" v-click-out-side>
    <div class="select__container">
      <input type="text" readonly placeholder="请选择" :value="activeVal">
      <img src="@/assets/images/1/drop.png" alt="">
    </div>
    <ul class="select__options" v-if="isVisable">
      <li
        v-for="(item, ind) in selectList"
        :key="ind"
        :class="item.value === value ? 'select' : ''"
        @click="handleChoose(item.value)"
      >
        {{item.label}}
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'c-simple-select',
  props: {
    value: {
      type: String,
      default: () => '10day',
    },
    selectList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isVisable: false, // 控制面板是否可见
      // selectList: [],
    };
  },
  computed: {
    activeVal() {
      let val;
      this.selectList.forEach((item) => {
        if (item.value === this.value) {
          val = item.label;
        }
      });
      return val;
    },
  },
  directives: {
    clickOutSide: { // 指令的生命周期
      bind(el, bindings, vnode) {
        // 把事件绑定在document上
        const handler = (e) => {
          if (el.contains(e.target)) {
            // 判断一下是否当前面板已经显示出来了
            if (!vnode.context.isVisable) {
              vnode.context.focus();
            }
          } else if (vnode.context.isVisable) {
            vnode.context.blur();
          }
        };
        // eslint-disable-next-line no-param-reassign
        el.handler = handler;
        document.addEventListener('click', handler);
      },
      unbind(el) {
        document.removeEventListener('click', el.handler);
      },
    },
  },
  methods: {
    focus() {
      this.isVisable = true;
    },
    blur() {
      this.isVisable = false;
    },
    handleChoose(val) {
      this.$emit('onSelectChange', val);
      this.blur(); // 关闭面板
    },
  },
};
</script>
<style>
.simple__select {
  width: fit-content;
  position: relative;
}
.select__container {
  height: 28px;
  /* padding: 10px; */
  border: 1px solid rgba(255, 255, 255, .3);
  display: flex;
  position: relative;
  width: fit-content;
  cursor: pointer;
}
.select__container input {
  display: block;
  height: 28px;
  width: 100%;
  font-family: PingFangSC-Regular;
  font-size: 12px;
  color: #FFFFFF;
  letter-spacing: 0.12px;
  line-height: 14px;
  font-weight: 400;
  text-align: center;
  padding: 0 20px 0 10px;
  cursor: pointer;
}
.select__container img {
  position: absolute;
  right: 8px;
  top: 12px;
  width: 14px;
  height: fit-content;
}
.select__options {
  width: 100%;
  position: absolute;
  top: 28px;
  left: 0;
  border: 1px solid rgba(255, 255, 255, .3);
  box-sizing: border-box;
  z-index: 100;
}
.select__options li {
  font-family: PingFangSC-Regular;
  font-size: 12px;
  color: #FFFFFF;
  letter-spacing: 0.12px;
  line-height: 14px;
  font-weight: 400;
  /* margin-top: 6px; */
  text-align: center;
  padding: 5px 0;
  z-index: 100;
  cursor: pointer;
}
.select__options li.select, .select__options li:hover {
  background: rgba(255,255,255,0.23);
}

</style>
